import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { translate } from '../../../../utils/util';
import { checkPermission } from '../../../../services/auth';
import { PERMISSIONS, ENUMS } from '../../../../utils/constants';
import * as actionsInventory from '../../../../actions/inventoryAction';
import { ListLinkBox, Title, Subtitle, BackButton } from '../../../../components/UI/ComponentsUI';

const InventoryGeneralDrone = (props) => {
    const menu = () => {
        let menuItems = [];
        if (checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.Supervisor : PERMISSIONS.Inventory.Rotative.Supervisor)) {
            menuItems = [...menuItems, { route: 'droneItems', icon: 'mdi mdi-clipboard-list-outline', text: translate('inventory:general.menu.inventoryItems') }];
            menuItems = [...menuItems, { route: 'rowHeaderReport', icon: 'mdi mdi-file-document-outline', text: translate('inventory:general.menu.reportDroneLine') }];
        }

        if (checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.Operational : PERMISSIONS.Inventory.Rotative.Operational)
            && props.filter.statusInventory !== ENUMS.eInventoryLotStatus.Finished && props.filter.statusInventory !== ENUMS.eInventoryLotStatus.Canceled
        ) {
            // eslint-disable-next-line max-len
            menuItems = [...menuItems, { route: { pathname: './lotItems', state: { lotOriginId: ENUMS.eInventoryOriginCount.Drone.value } }, icon: 'mdi mdi-cellphone-android', text: translate('inventory:general.menu.droneFirstLine') }];
            // eslint-disable-next-line max-len
            menuItems = [...menuItems, {
                route: { pathname: './lots', state: { byFilter: true, divergentDrone: true } },
                icon: 'mdi mdi-numeric-2-circle-outline',
                text: translate('inventory:general.menu.droneSecondReading'),
                onClick: () => {
                    const filter = props.filter;
                    filter.divergent = true;
                    filter.lotOriginId = ENUMS.eInventoryOriginCount.Drone.value;
                    props.setFilter(filter);
                }
            }];
        }

        return menuItems;
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-check-outline" label={translate('inventory', 'inventory')} />
                    <Subtitle icon="mdi mdi-quadcopter" label={translate('general.menu.drone', 'inventory')} />
                </div>
            </div>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox options={menu()} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.inventoryReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilter: (filter) => {
            dispatch(actionsInventory.setFilterInventoryLot(filter));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(InventoryGeneralDrone)));
